import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { AnimationDirection, AnimationDirectionType } from './menuAnimations.util';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';
import { useTheme } from '../../../../theming/useTheme';

interface AccessibilityIconProps {
  accessibilityIconNormalColor: string;
  accessibilityIconHoverColor: string;
  menuAnimation: AnimationDirectionType;
}

const createStyle = (accessibilityIconHoverColor: string, accessibilityIconNormalColor: string, baseUnit: BaseUnit, menuAnimation: AnimationDirectionType) => {
  return StyleSheet.create({
    svg: {
      fill: accessibilityIconNormalColor,
      ':hover': {
        fill: accessibilityIconHoverColor,
      },
      height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
      width: 'auto',
    },
    button: {
      cursor: 'pointer',
      display: 'flex',
    },
  });
};
export const AccessibilityIcon: React.FunctionComponent<AccessibilityIconProps> = props => {
  const { accessibilityIconNormalColor, menuAnimation, accessibilityIconHoverColor } = props;
  const { baseUnit } = useTheme();
  const style = createStyle(accessibilityIconHoverColor, accessibilityIconNormalColor, baseUnit, menuAnimation);
  const onClick = () => {
    try {
      // @ts-ignore TS2339
      if (window.interdeal) {
        // @ts-ignore TS2339
        window.interdeal.a11y.openMenu();
      }
    } catch (e) {
      console.error('Error when clicking on accessibilityIcon', e);
    }
  };
  return (
    <button type="button" onClick={onClick} aria-label="accessibility" className={css(style.button)}>
      <svg className={css(style.svg, style.button)} version="1.1" viewBox="0 0 50 50">
        <g transform="translate(50 50) scale(-.69 .69) translate(-50 -50)">
          <path d="m99 39.8-1.9-7.7c-2.8 6.9-9.5 11.9-17.4 11.9-10.3 0.1-18.7-8.3-18.7-18.7 0-7.3 4.2-13.6 10.4-16.7l-1.1-6c-8.9 3.8-15.2 12.5-15.2 22.7 0 13.6 11.1 24.7 24.7 24.7 7.9 0 15-3.8 19.5-9.6-0.2-0.2-0.3-0.4-0.3-0.6z" />
          <path d="m112.7 32.4-4 1-4.5-18.1c-0.4-1.8-2-3-3.9-3h-17.2l-0.9-4.5h11.4c2.2 0 3.9-1.8 3.9-3.9s-1.8-3.9-3.9-3.9h-12.9l-1.7-8.5c2.5-1.2 4.2-3.7 4.2-6.6 0-4-3.3-7.3-7.3-7.3s-7.3 3.3-7.3 7.3c0 1.9 0.7 3.6 1.8 4.8l5.3 27.4c0.4 1.9 2 3.3 3.9 3.3h17.4l4.7 18.9c0.5 1.8 2.1 3 3.9 3 0.3 0 0.6 0 0.9-0.1l7.9-1.9c2.1-0.5 3.5-2.7 2.9-4.7-0.4-2.4-2.6-3.7-4.6-3.2z" />
        </g>
      </svg>
    </button>
  );
};
